module.exports = __webpack_public_path__ + "img/en.6a9aba7e.svg";